export default () => ({
    headings: [],
    tocOpen: false,
    init() {
      console.log("Initializing Table of Contents...");
  
      const root = this.$root;
  
      const ignoreTypes = root.dataset.ignoreBlocks
        ? root.dataset.ignoreBlocks.split(",").map(s => s.trim()).filter(Boolean)
        : [];
  
      const ignoreClasses = root.dataset.ignoreClasses
        ? root.dataset.ignoreClasses.split(",").map(s => s.trim().replace(/^\./, "")) // remove leading dot
        : [];
  
      console.log("Ignore block-types:", ignoreTypes);
      console.log("Ignore classes:", ignoreClasses);
  
      const content = document.getElementById("page-content");
      if (!content) {
        console.warn("No #page-content found!");
        return;
      }
  
      const headingElements = Array.from(
        content.querySelectorAll("h1, h2, h3, h4, h5, h6")
      ).filter(heading => {
        let el = heading.parentElement;
  
        while (el) {
          if (el.hasAttribute("block-type") && ignoreTypes.includes(el.getAttribute("block-type"))) {
            return false;
          }
  
          if (ignoreClasses.some(cls => el.classList.contains(cls))) {
            return false;
          }
  
          el = el.parentElement;
        }
  
        return true;
      });
  
      if (headingElements.length === 0) {
        console.warn("No valid headings found inside #page-content!");
        return;
      }
  
      let headingList = [];
      let headingStack = [{ level: 0, children: headingList }];
  
      headingElements.forEach((heading, index) => {
        const level = parseInt(heading.tagName.substring(1));
        const id = `toc-${index}`;
        heading.id = id;
  
        const item = {
          id,
          text: heading.textContent.trim(),
          level,
          children: []
        };
  
        while (headingStack.length && headingStack[headingStack.length - 1].level >= level) {
          headingStack.pop();
        }
  
        headingStack[headingStack.length - 1].children.push(item);
        headingStack.push(item);
  
        if (level === 1) {
          headingList.push(item);
        }
      });
  
      this.$nextTick(() => {
        this.headings = headingList;
        console.log("Updated TOC Headings:", JSON.stringify(this.headings, null, 2));
      });
    },
    scrollToHeading(id) {
      const offset = 120;
      const el = document.getElementById(id);
      if (!el) return;
  
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  });
  